import * as React from "react";
import {Children, CSSProperties, ReactElement} from "react";
import {StoreControl, StoreControlProps, StoreControlState} from "shared/controls/base/StoreControl";
import {ValidatorBase} from "shared/utilities/validator/ValidatorBase";
import {PropertyValidator} from "shared/utilities/validator/PropertyValidator";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTags} from "@fortawesome/free-solid-svg-icons/faTags";
import './RNTags.css';
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {observer} from "mobx-react";
import {RNTagDialog} from "./RNTagDialog";
import {RNTagGroup, RNTagGroupProps} from "./RNTagGroup";
import {StoreBase} from "shared/core/Store/StoreBase";
import {Editor} from "shared/lib/slate-react";
import {RNTagsSlatePlugin} from "shared/controls/RNTags/RNTagsSlatePlugin";
import {Inline, Operation, Value} from "shared/lib/slate";
import { List } from "immutable";
import {RNTagsSlateRenderer} from "shared/controls/RNTags/RNTagsSlateRenderer";
import {RNTagItem} from "shared/controls/RNTags/RNTagItem";
import {RNTagGroupModel} from "shared/controls/RNTags/RNTagGroup.Model";
import {RNTagItemModel} from "shared/controls/RNTags/RNTagItem.Model";

@observer
export class RNTags<S extends StoreBase> extends StoreControl<RNTagsProps<S>, RNTextInputState> {
    static defaultProps: Partial<RNTagsProps<any>> = {
        skipTags:[],
        DefaultValue:''
    };
    Input:HTMLInputElement;
    public Schemas:any;
    public Plugins:any;
    public editor:Editor;
    public ObjectsToLoad=null;
    public Data:RNTagGroupModel[];


    constructor(props: RNTagsProps<S>) {
        super(props);
        this.state={
            IsValid:true,
            ErrorMessage:'',
            Value:this.PrepareContent(props)
        };
        this.Data=[];
        this.RenderEditor=this.RenderEditor.bind(this);
        this.Plugins=[RNTagsSlatePlugin]

        this.Schemas={};
        this.Schemas.blocks={};
        this.Schemas.document={
            nodes: [
                {
                    match: { type: 'paragraph' },
                    min: 1,
                    max: 1
                },
            ]

        };
        this.Schemas.inlines={};
        this.Schemas.inlines.field={isVoid:true};
        this.GenerateData(null);
    }
    componentDidUpdate(prevProps: Readonly<RNTagsProps<S>>, prevState: Readonly<RNTextInputState>, snapshot?: any) {
        this.GenerateData(null);
    }

    private PrepareContent(props: RNTagsProps<S>) {
        let value=this.GetObjectValue();
        if(value==null)
            this.SetValue({
                document: {
                    nodes: [
                        {
                            object: 'block',
                            type: 'paragraph',
                            nodes: [
                                {
                                    object: 'text',
                                    leaves: [
                                        {
                                            text: this.props.DefaultValue,
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            });

        this.ObjectsToLoad=Value.fromJSON(this.GetObjectValue());
        return    Value.fromJSON({
            document: {
                nodes: [
                    {
                        object: 'block',
                        type: 'paragraph',
                        nodes: [
                            {
                                object: 'text',
                                leaves: [
                                    {
                                        text: this.props.DefaultValue,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        }as any);

    }
    public render() {
        return (
            <div className={'rncontrol'}>
                <div>
                    <label style={{width:'100%',display:'block'}}>{this.props.Label}</label>
                </div>
                <div style={{position:'relative'}}>
                    <Editor schema={this.Schemas}  className={'fieldPickerTextBox'}
                            renderNode={(props,editor,next)=>this.RenderNode(props,editor,next)}
                            ref={this.RenderEditor} value={this.state.Value}
                            onFocus={()=>{}}
                            onChange={e=>{this.Change(e);this.props.OnChange&&this.props.OnChange()}}   plugins={this.Plugins}  />
                    {

                        <div className={'rnTagIcon'} style={{
                            position: 'absolute',
                            right: 3,
                            top: '50%',
                            marginTop: -8,
                            fontSize: 16,
                            cursor: 'pointer'
                        }} onClick={() => this.OpenDialog()}>
                            <FontAwesomeIcon icon={faTags}/>
                        </div>
                    }
                </div>
            </div>
        )
    }

    private RenderNode(props: any, editor: any, next: () => any) {
        const { attributes, children, node } = props;

        if(props.node.type=='paragraph') {
            let styles:CSSProperties={};


            return <span {...attributes} style={styles}>{children}</span>
        }


        if(props.node.type=='field')
        {
            return <RNTagsSlateRenderer Node={props.node} Editor={editor} SlateProps={props} Tags={this.Data}/>
        }


        return next();
    }

    GetValidators(): ValidatorBase[] {
        return [
            new PropertyValidator(this.props,"Required",()=>{return this.GetStringValue()!=''},"Required field")
        ];
    }
    public RenderEditor(node:any)
    {
        this.editor=node;

        if(this.editor!=null)
        {
            this.setState( {
                Value: this.ObjectsToLoad
            } )as any
        }
    }


    private Change(e: { operations: List<Operation>; value: Value }) {

        if(this.state.Value.document!=e.value.document) {
            this.SetValue(e.value.toJSON());
        }
        this.setState({Value:e.value});


    }
    private async OpenDialog() {
        if(this.props.OnOpeningDialog!=null&&!this.props.OnOpeningDialog())
            return;

        let result:RNTagItemModel=await Dialog.Show(<RNTagDialog Data={this.Data} SkipTags={this.props.skipTags}/>);

        if(result==null)
            return;

        let block=Inline.create(
            {
                type:'field',
                data:{
                    SubType:result.Item.Type,
                    FieldId:result.Item.Value,
                    IncludeLabel:false,
                }
            }
        );
        let node=this.editor.insertInline(block);


    }

    private GenerateData(props:RNTagsProps) {
        this.Data=[];
        let children:ReactElement<RNTagGroupProps>[]=Children.toArray(this.props.children) as any;
        for(let group of children)
        {

            let createdGroup=new RNTagGroupModel(group.props);
            this.Data.push(createdGroup);
            let subitems:ReactElement<any>[]=Children.toArray((group.props as any).children) as any;
            for(let item of subitems)
            {
                createdGroup.Children.push(new RNTagItemModel(item.props));
            }

        }




    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface RNTagsProps<S extends StoreBase=StoreBase> extends StoreControlProps<S>{
    style?:CSSProperties;
    Label:string;
    onChange?:(value:string)=>void;
    disabled?:boolean;
    type?:string;
    placeholder?:string;
    skipTags:string[];
    OnChange:()=>void;
    DefaultValue:string;
    OnOpeningDialog:()=>boolean;
}

interface RNTextInputState extends StoreControlState{
    Value:Value;

}

//#endregion "My Region"